<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox width">
          <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="凭证编码" style="width: 250px">
                <el-input v-model="formInline.BELNR" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="过账日期" prop="budatFrom" style="width: 50%;">
                <el-date-picker v-model="formInline.budatFrom" clearable type="date" value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker v-model="formInline.budatTo" clearable type="date" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="客户编号/名称">
                <el-input v-model="formInline.receUserLike" placeholder="请输入客户编号/名称" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30 tableclslist">
        <el-table :data="tableData" style="width: 100%" :border="true" max-height="450" :summary-method="getSummaries" show-summary>
          <el-table-column fixed type="index" label="#" width="60"></el-table-column>
          <el-table-column prop="gjahr" label="会计年度" width="90" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="receUsercode" label="客户编码" width="120" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column prop="receUsername" label="客户名称" :show-overflow-tooltip="true" width="230" ></el-table-column>
          <el-table-column prop="bukrs" label="公司代码" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="budat" label="凭证过账日期" width="110" :formatter="formatDatecc" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="belnr" label="凭证编号" width="110" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="wrbtr" label="金额" width="110"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="sgtxt" label="文本" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="formInline" @query="searchReset"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportDetailsExcel()">批量导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";
export default {
  components: {updownfile},
  data() {
    return {
      //表单
      formInline: {
        //月份
        months: null,
        //销售组织
        BUKRS: null,
        //客户编码
        receUserLike: null,
        //客户名称
        receUsername: null,
        //年度
        GJAHR:null,
        //凭证编码
        BELNR:null,
        customerType:'',
        total: 0,
        pageSize: 10,
        pageNo: 1,
        budatFrom: null,
        budatTo: null,
      },
      tableData:[],
      gongsiList:[],
    }
  },
  created() {
    this.formInline.BUKRS = '44U0';
    this.formInline.budatFrom = this.formatDate(new Date());
    // this.formInline.budatTo = this.formatDate(new Date());
    this.searchReset();
  },
  methods: {
    //查询数据
    searchReset(){
      ss.salesList.selectDetailYxPage(this.formInline).then(response => {
        this.tableData = response.records;
        this.formInline.total = response.total;
      })
    },
    //重置查询条件
    resetData(){
      this.formInline.BELNR = null;
      this.formInline.budatFrom = null;
      this.formInline.budatTo = null;
      this.formInline.receUserLike = null;
    },
    //导出
    exportDetailsExcel(){
      updownfile.down("/api/swyl/v1/domestic/userReceDomestic/exportDetailYxExcel",this.formInline,"post",'sata');
    },
    //格式化时间
    formatDatecc(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null || data == '') {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // 第一列：显示 合计
        if (index === 0) {
          sums[index] = '合计';
        }
        else if (index === 7) {
          // 提取当前列所有数据，转为数字
          const values = data.map(item => Number(item[column.property]));
          // 累加求和（过滤非数字）
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        }
        // 其他所有列：置空
        else {
          sums[index] = '';
        }
      });
      return sums;
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  }
}
</script>

<style>

</style>
